import type { Meta, StoryObj } from "@storybook/react";

import { ReplayAnimationDecorator } from "@/__stories__/ReplayAnimationDecorator";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import type { ScaleInViewProps } from "@/ui/layout/animated/ScaleInView";
import { ScaleInView } from "@/ui/layout/animated/ScaleInView";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<ScaleInViewProps> = {
  title: "Layout/Animated/Scale In View",
  component: ScaleInView,
  argTypes: {
    delay: {
      control: { max: 3000, min: 0, step: 100, type: "number" },
    },
  },
  args: {
    delay: 0,
  },
};

type Story = StoryObj<ScaleInViewProps>;

const Default: Story = {
  render: (args) => {
    return (
      <ReplayAnimationDecorator>
        <ScaleInView delay={args.delay}>
          <Box
            alignItems="center"
            backgroundColor={ColorToken.Primary10}
            borderRadius={12}
            justifyContent="center"
            padding={40}
          >
            <Text testID="story-text" variant="body">
              Scales in from 0.86
            </Text>
          </Box>
        </ScaleInView>
      </ReplayAnimationDecorator>
    );
  },
};

const WithDelay: Story = {
  args: {
    delay: 500,
  },
  render: (args) => {
    return (
      <ReplayAnimationDecorator>
        <ScaleInView delay={args.delay}>
          <Box
            alignItems="center"
            backgroundColor={ColorToken.Primary10}
            borderRadius={12}
            justifyContent="center"
            padding={40}
          >
            <Text testID="story-text" variant="body">
              500ms delay
            </Text>
          </Box>
        </ScaleInView>
      </ReplayAnimationDecorator>
    );
  },
};

export { Default, WithDelay };
export default StoryMeta;
